import { alertService, createStorePersist, RequestStatus } from "common-frontend-components";
import { useEffect } from "react";
import { postCategoryAssociationsStore } from "./usePostCategoryAssociationsStore";
import { getStorageCall } from "@yehonadav/safestorage";
import { categoriesStore } from "../useCategoriesStore";
import { callGetPostsAsync } from "../../apis/posts";
const getDefaultNewPost = () => ({
    title: '',
    description: '',
    categories: [],
    files: [],
    links: [],
    products: [],
    index: undefined,
});
const persistOptions = {
    name: `ramibarilan/posts/store`,
    whitelist: ["posts"],
    getStorage: getStorageCall,
};
const { useStore, fetchStore, set, get } = createStorePersist({
    persistOptions,
    persistAfterClearingStorage: false,
    getDefaultValues: () => ({
        posts: {},
        newPost: getDefaultNewPost(),
        dataFiltered: [],
        pageIndex: 0,
        rowsPerPage: 9,
        pageItems: [],
        requestStatus: RequestStatus.pending,
    })
});
const getPosts = () => Object.values(get().posts);
const setPosts = (postList) => {
    const posts = {};
    postList.forEach(post => { posts[post.id] = post; });
    set({ posts });
};
// set posts from storage
setPosts(getPosts().map(i => { i.created = new Date(i.created); return i; }));
const getDataFiltered = () => get().dataFiltered;
const getPageIndex = () => get().pageIndex;
const getRowsPerPage = () => get().rowsPerPage;
const getPageItems = () => get().pageItems;
const setDataFiltered = (dataFiltered) => set({ dataFiltered });
const setPageIndex = (pageIndex) => set({ pageIndex });
const setRowsPerPage = (rowsPerPage) => set({ rowsPerPage });
const setPageItems = (pageItems) => set({ pageItems });
const handleChangePage = (_event, newPage) => {
    setPageIndex(newPage);
};
const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPageIndex(0);
};
const _getPageItems = () => {
    const rowsPerPage = getRowsPerPage();
    const skip = getPageIndex() * rowsPerPage;
    return getDataFiltered().slice(skip, skip + rowsPerPage);
};
const usePosts = () => Object.values(useStore(fetchStore.posts));
const useDataFiltered = () => useStore(fetchStore.dataFiltered);
const usePageItems = () => useStore(fetchStore.pageItems);
const usePageIndex = () => useStore(fetchStore.pageIndex);
const useRowsPerPage = () => useStore(fetchStore.rowsPerPage);
const useFilterData = () => {
    const categoryFilters = categoriesStore.useCategoryFilters();
    const data = usePosts();
    useEffect(() => {
        let filteredData = data;
        if (categoryFilters.length > 0) {
            filteredData = [];
            categoryFilters.forEach(category => {
                const posts = postCategoryAssociationsStore.getCategoryPosts(category.id);
                posts.forEach(post => {
                    if (!filteredData.includes(post))
                        filteredData.push(post);
                });
            });
        }
        // @ts-ignore
        setDataFiltered(filteredData.sort((a, b) => b.created - a.created));
    }, [
        data,
        categoryFilters,
    ]);
};
const useGetPageItems = () => {
    const dataFiltered = useDataFiltered();
    const pageIndex = usePageIndex();
    const rowsPerPage = useRowsPerPage();
    useEffect(() => {
        setPageItems(_getPageItems());
    }, [dataFiltered, pageIndex, rowsPerPage]);
};
export const postsStore = {
    clearNewPost: () => set({ newPost: getDefaultNewPost() }),
    getNewPost: () => get().newPost,
    setNewPost: (newPost) => set({ newPost }),
    setNewPostPreviewImg: (preview) => set(s => ({ newPost: { ...s.newPost, preview } })),
    setNewPostLinks: (links) => set(s => ({ newPost: { ...s.newPost, links } })),
    setNewPostProducts: (products) => set(s => ({ newPost: { ...s.newPost, products } })),
    setNewPostFiles: (files) => set(s => ({ newPost: { ...s.newPost, files } })),
    setNewPostIndex: (index) => set(s => ({ newPost: { ...s.newPost, index } })),
    useNewPostLinks: () => useStore(s => s.newPost.links),
    useNewPostProducts: () => useStore(s => s.newPost.products),
    useNewPostCategories: () => useStore(s => s.newPost.categories),
    useNewPostTitle: () => useStore(s => s.newPost.title),
    useNewPostPreviewImg: () => useStore(s => s.newPost.preview),
    useNewPostIndex: () => useStore(s => s.newPost.index),
    handleNewPostTitleChange: (e) => set(s => ({ newPost: { ...s.newPost, title: e.target.value } })),
    useNewPostDescription: () => useStore(s => s.newPost.description),
    handleNewPostDescriptionChange: (e) => set(s => ({ newPost: { ...s.newPost, description: e.target.value } })),
    useNewPostFiles: () => useStore(s => s.newPost.files),
    getPostMap: () => get().posts,
    getPosts,
    setPosts,
    usePosts,
    getDataFiltered,
    getPageIndex,
    getRowsPerPage,
    getPageItems,
    setDataFiltered,
    setPageIndex,
    setRowsPerPage,
    setPageItems,
    handleChangePage,
    handleChangeRowsPerPage,
    useDataFiltered,
    usePageItems,
    usePageIndex,
    useRowsPerPage,
    useFilterData,
    useGetPageItems,
    getRequestStatus: () => get().requestStatus,
    // tslint:disable-next-line:no-shadowed-variable
    setRequestStatus: (requestStatus) => { console.log({ requestStatus }); const s = get(); s.requestStatus = requestStatus; set({ requestStatus }); },
    useRequestStatus: () => useStore(fetchStore.requestStatus),
    useLoad: () => {
        const status = postsStore.useRequestStatus();
        const data = postsStore.usePosts();
        useEffect(() => {
            if (get().requestStatus !== RequestStatus.pending)
                return;
            postsStore.setRequestStatus(RequestStatus.loading);
            callGetPostsAsync()
                .then((items) => {
                postsStore.setPosts(items);
                postsStore.setRequestStatus(RequestStatus.loaded);
            })
                .catch((e) => {
                alertService.error(e);
                postsStore.setRequestStatus(RequestStatus.failed);
            });
        }, [status]);
        return { status, data };
    },
};
//# sourceMappingURL=postsStore.js.map